export const ACCESS_TOKEN_KEY = 'lam_auth_token'
export const REFRESH_TOKEN_KEY = 'lam_refresh_token'
export const SESSION_BY_ID = 'session_by_id'
